import React, { createContext, useContext, useState } from 'react';

import { IDrawingContext, IProviderProps } from '../@types/ContextProviderRelated';

const drawingContextDefaultValues: IDrawingContext = {
    isDrawing: false,
    setIsDrawing: () => {},
    roomCompleted: false,
    setRoomCompleted: () => {}
}

const DrawingContext = createContext<IDrawingContext>(drawingContextDefaultValues);

export const DrawingProvider = ({ children }: IProviderProps): JSX.Element => {
    const [isDrawing, setIsDrawing] = useState(false);
    const [roomCompleted, setRoomCompleted] = useState(false);

    const drawingContextValue = {
        isDrawing,
        setIsDrawing,
        roomCompleted,
        setRoomCompleted
    };

    return (
        <DrawingContext.Provider value={drawingContextValue}>
            {children}
        </DrawingContext.Provider>
    );
};

export const useDrawing = () => useContext(DrawingContext);
